import styled from 'styled-components';

export const Wrap = styled.div`
  width: 25%;
`;

export const Title = styled.h2``;
